"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveTcoInputs = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.saveTcoInputs = (0, graphql_tag_1.default) `
  mutation SaveTcoInputsMutation($input: CalculateTcoInputType!) {
    saveTcoInputs(input: $input) {
      id
      tcoErrors {
        errors
        systemErrors {
          systemId
          error
        }
      }
    }
}`;
//# sourceMappingURL=save-tco-inputs.js.map